import { render, staticRenderFns } from "./receiving-details-comp.vue?vue&type=template&id=06783bce&scoped=true&"
import script from "./js/receiving-details-comp.js?vue&type=script&lang=js&"
export * from "./js/receiving-details-comp.js?vue&type=script&lang=js&"
import style0 from "../../assets/styles/receiving-styles.css?vue&type=style&index=0&id=06783bce&prod&scoped=true&lang=css&"
import style1 from "./receiving-details-comp.vue?vue&type=style&index=1&id=06783bce&prod&scoped=true&lang=css&"
import style2 from "./receiving-details-comp.vue?vue&type=style&index=2&id=06783bce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06783bce",
  null
  
)

export default component.exports